import { useQuery } from "@tanstack/react-query";
import { listFiles, searchLibrary } from "utils/collegeDocumentService";
import { FILES_QUERY_KEY, SEARCH_QUERY_KEY } from "./documentLibraryQueryKeys";

/** Loads the selected folder's files, and search hits whenever a search term is active. */
export const useFileData = (universityId, selectedFolderId, activeSearch) => {
  const filesQuery = useQuery({
    queryKey: [FILES_QUERY_KEY, universityId, selectedFolderId],
    queryFn: () => listFiles(universityId, selectedFolderId),
    enabled: Boolean(selectedFolderId),
  });

  const searchQuery = useQuery({
    queryKey: [SEARCH_QUERY_KEY, universityId, selectedFolderId, activeSearch],
    queryFn: () => searchLibrary({ universityId, folderId: selectedFolderId, q: activeSearch }),
    enabled: activeSearch.trim().length > 0,
  });

  return { filesQuery, searchQuery };
};
